/* eslint-disable @typescript-eslint/no-explicit-any */
import { CreateOpportunityFlow, OpportunityFlow } from '@/entities/opportunityFlow';
// import axios from 'axios';
import Constants from '@/constants';
import { OpportunityFlowWithBusiness } from '@/entities/opportunityFlowWithBusiness';
import { Api } from './api/axios-config';

export class OpportunityFlowService {

  private static api = Api();

  public static async getOpportunityFlow(): Promise<OpportunityFlow[] | null> {
    // axios call
    const response = await this.api.get<any>('/opportunity-flow');

    if (response.status === 200) {
      return response.data.map((data: any) => ({
        id: data.id,
        description: data.description,
        order: data.order,
      }));
    }

    return null;
  }
  public static async searchOpportunityFlow(contain: string): Promise<OpportunityFlow[] | null> {
    try {
      const response = await this.api.post<any>('/opportunity-flow/find-contain', { contain });
      // console.log(response.data);
      if (response.status === 201) {
        const founded = response.data.map((data: any) => ({
          id: data.id,
          description: data.description,
          order: data.order,
        }));
        // console.log('Encontrado');
        // console.log(founded);
        return founded;

      }
    } catch (error) {
      console.error('Error fetching opportunity flows:', error);
    }

    return null;
  }

  public static async createNewOpportunityFlow(newOpportunityFlow: { description: string }): Promise<OpportunityFlow | null> {
    const response = await this.api.post<any>('/opportunity-flow', newOpportunityFlow);

    if (response.status === 201) {
      return {
        id: response.data.id,
        description: response.data.description,
        order: response.data.order,
      };
    }
    return null;
  }
  public static createManyOpportunityFlow = async (opportunityFlows: CreateOpportunityFlow[]) => {
    const response = await this.api.post<any>(`/${opportunityFlows}`);

    if (response.status === 201) {
      return opportunityFlows.map(op => ({
        description: op.description,
        order: op.order,
      }));
    }
    return null;
  };
  public static async deleteOpportunityFlow(id: number): Promise<OpportunityFlow | null> {
    try {
      const response = await this.api.delete<any>(`/opportunity-flow/${id}`);

      if (response.status === 200) {

        return {
          id: response.data.id,
          description: response.data.description,
          order: response.data.order,
        };
      }
      return null;
    } catch (error) {
      console.error('Erro ao excluir o fluxo de oportunidade:', error);
      return null;
    }
  }

  public static async getOpportunityFlowWithBusiness(): Promise<OpportunityFlowWithBusiness[] | null> {
    // axios call
    const response = await this.api.get<any>('/opportunity-flow-with-business');

    if (response.status === 200) {
      return response.data.map((data: any) => ({
        id: data.id,
        description: data.description,
        order: data.order,
        business: data.business.map((business: any) => ({
          id: business.id,
          contactNumber: business.contactNumber,
          description: business.description,
          status: business.status,
          closedAt: business.closedAt,
          startedAt: business.startedAt,
          prevision: business.prevision,
          clientId: business.clientId,
        }))
      }));
    }

    return null;
  }

  public static async getOpportunityFlowWithBusinessbyId(userId: number, companyId: number): Promise<OpportunityFlowWithBusiness[] | null> {
    // axios call
    const response = await this.api.get<any>(`/opportunity-flow-with-business/${companyId}/${userId}`);

    if (response.status === 200) {
      return response.data.map((data: any) => ({
        id: data.id,
        description: data.description,
        order: data.order,
        business: data.business.map((business: any) => ({
          id: business.id,
          contactNumber: business.contactNumber,
          description: business.description,
          status: business.status,
          closedAt: business.closedAt,
          startedAt: business.startedAt,
          prevision: business.prevision,
          clientId: business.clientId,
        }))
      }));
    }

    return null;
  }

  public static async swapOpportunityFlows(firstOpportunityFlowId: number, secondOpportunityFlowId: number): Promise<OpportunityFlow[] | null> {
    const response = await this.api.post<any>('/opportunity-flow/change-order', {
      firstOpportunityFlowId: firstOpportunityFlowId,
      secondOpportunityFlowId: secondOpportunityFlowId
    });

    if (response.status === 201) {
      return response.data.map((data: any) => ({
        id: data.id,
        description: data.description,
        order: data.order,
      }));
    }

    return null;
  }

  // change opportunity flow of business
  public static async changeOpportunityFlowOfBusiness(businessId: number, opportunityFlowId: number,contactNumber: string): Promise<OpportunityFlowWithBusiness[] | null> {
    const response = await this.api.post<any>('/business/change-opportunity-flow', {
      businessId: businessId,
      newOpportunityFlowId: opportunityFlowId,
      contactNumber: contactNumber
    });

    if (response.status === 201) {
      return response.data.map((data: any) => ({
        id: data.id,
        description: data.description,
        order: data.order,
        business: data.business.map((business: any) => ({
          id: business.id,
          contactNumber: business.contactNumber,
          description: business.description,
          status: business.status,
          closedAt: business.closedAt,
          startedAt: business.startedAt,
          prevision: business.prevision,
          clientId: business.clientId,
        }))
      }));
    }

    return null;
  }

  public static async updateManyOpportunityFlow(opportunitiesFlows: OpportunityFlow[]): Promise<OpportunityFlow[] | null> {

    const response = await this.api.post<any>('/opportunity-flow/update-many', {
      opportunitiesFlows: opportunitiesFlows.map((opportunityFlow) => ({
        id: opportunityFlow.id,
        description: opportunityFlow.description,
        order: opportunityFlow.order
      }))
    });

    if (response.status === 201) {
      return response.data.map((data: any) => ({
        id: data.id,
        description: data.description,
        order: data.order,
      }));
    }

    return null;
  }
}
